export function formatPrice(price: number) {
  return new Intl.NumberFormat('de-DE', {
    currency: 'EUR',
    maximumFractionDigits: 2,
    style: 'currency',
  }).format(price);
}
